import React from 'react';
import AppointmentDetailsPresenter from './AppointmentDetailsPresenter';
import { CernerAppointmentDetails } from '../../api/models';
import { useSchedulingContext } from '../context';

export interface AppointmentDetailsWrapperProps {
  appointmentDetails: CernerAppointmentDetails;
}

const AppointmentDetailsWrapper: React.FC<AppointmentDetailsWrapperProps> = (
  props: AppointmentDetailsWrapperProps
) => {
  const schedulingDetails = useSchedulingContext();

  return (
    <AppointmentDetailsPresenter
      appointmentDetails={props.appointmentDetails}
      schedulingDetails={schedulingDetails}
    />
  );
};

export default AppointmentDetailsWrapper;
